import { setHeader, TEST_API } from "..";
import axios from "axios";
// eslint-disable-next-line import/no-anonymous-default-export
export default {
  getSubscriptionInfo: (subscriptionId, deep_link_token) => {
    let config = {
      method: "GET",
      baseURL: `${TEST_API}/subscriptions/${subscriptionId}${deep_link_token ? `?deep_link_token=${deep_link_token}` : ''}`,
      headers: setHeader(),
    };
    return axios(config).then((res) => res.data);
  },
  getSubscriptionPromocodeInfo: (promocode) => {
    let config = {
      method: "GET",
      baseURL: `${TEST_API}/promocode?code=${promocode}`,
      headers: setHeader(),
    };
    return axios(config);
  },
    getSubscriptionList: (cardId, booked = false, deep_link_token) => {
      let config = {
        method: "GET",
        baseURL: `${TEST_API}/subscriptions/cards/${cardId}${ booked ? "?filter[onlyBooked]=true" : ""}${deep_link_token ? `${booked ? '&' : '?'}deep_link_token=${deep_link_token}` : ''}`,
        headers: setHeader(),
      };
      return axios(config).then((res) => res.data);
    },
  bookSubscription: (subId, cardId, body) => {
    let config = {
      method: "POST",
      baseURL: `${TEST_API}/subscriptions/${subId}`,
      headers: {
        ...setHeader(),
        "payment-success-url": `${window.location.origin}/subscriptions/payment/success`,
      },
      data: { ...body, cardId },
    };
    return axios(config).then((res) => res.data);
  },
};